import { axiosInstance } from '@/services';
import { CONFIG } from '@/constants';
import { IGetStationsForMapParams } from '@/interfaces/Map';

class MapService {
  getStationById = async (id: number) =>
    axiosInstance.get(`/stations/${id}`).then((res) => res.data);

  getMetarByIcaoCode = async (icaoCode: string) =>
    await axiosInstance.get(`/metars/live/${icaoCode}?format=${CONFIG.API.QUERY_PARAMS.FORMAT}&taf=${CONFIG.API.QUERY_PARAMS.TAF}`)
      .then((res) => res.data);

  getTafByIcaoCode = async (icaoCode: string) =>
    await axiosInstance.get(`/tafs/live/${icaoCode}?format=${CONFIG.API.QUERY_PARAMS.FORMAT}&taf=${CONFIG.API.QUERY_PARAMS.TAF}`)
      .then((res) => res.data);

  getStationsForMap = async (params: IGetStationsForMapParams) =>
    await axiosInstance
      .get(`/stations/map-data?page=${params.page}&size=${params.size}&southwestLat=${params.southwestLat}&southwestLng=${params.southwestLng}&northeastLat=${params.northeastLat}&northeastLng=${params.northeastLng}`,
        {
          signal: params.cancellationSignal,
        }
      )
      .then((res) => res.data);


  getWeatherForecast = async (icaoCode: string) =>
    await axiosInstance.get(`weather/by-station?icaoCode=${icaoCode}`)
      .then((res) => res.data);

  getStationWithSearch = async (search: string) =>
    await axiosInstance.get(`/stations?countryCode=&search=${search}`)
      .then((res) => res.data);

}

export default new MapService();
